import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

const createSpacing = (unit: ThemeUnit) =>
  ({
    xs: pxToUnit(4, unit),
    sm: pxToUnit(8, unit),
    md: pxToUnit(16, unit),
    lg: pxToUnit(24, unit),
    xl: pxToUnit(32, unit),
    // Additional spacing values for more granular control
    0: "0",
    1: pxToUnit(4, unit),
    2: pxToUnit(8, unit),
    3: pxToUnit(12, unit),
    4: pxToUnit(16, unit),
    5: pxToUnit(20, unit),
    6: pxToUnit(24, unit),
    8: pxToUnit(32, unit),
    10: pxToUnit(40, unit),
    12: pxToUnit(48, unit),
    16: pxToUnit(64, unit),
    20: pxToUnit(80, unit),
  }) as const;

export const spacingRem = createSpacing("rem");
